import moment from "moment";

export function timezoneDateFormat() {
  const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  
  const newZealandTimezones = [
    'Pacific/Auckland', 
    'Pacific/Chatham',
    'NZ',
    'NZ-CHAT',
    'Etc/GMT-12',  
    'Etc/GMT-13'   
  ];
  
  const isNewZealand = newZealandTimezones.includes(currentTimezone);
  
  if (isNewZealand) {
    return "dd/MM/yyyy";
  }

  return "MM/dd/yyyy";
}

export const normalizeToCurrentTimezone = (date: Date): Date => {
    if (!date) return date;
        
    const today = new Date();
    const todayOffset = today.getTimezoneOffset();
    const dateOffset = date.getTimezoneOffset();
        
    if (todayOffset !== dateOffset) {
        const offsetDiff = dateOffset - todayOffset;
        const normalized = new Date(date.getTime() + offsetDiff * 60 * 1000);
        return normalized;
        }
    return date;
};

 export const getWindowEndTime = (dateTime: any, windowMinutes: number) => {
    return moment(dateTime).add(windowMinutes, 'minutes').format("h:mm a");
};